import StockBillMainContent from './components/StockBillMainContent'
import { useLocation } from 'react-router'
import { inventoryTypeEnum } from './config'
import { TypeContext } from './context/typs'
function StockIn() {
  const { state } = useLocation()
  return (
    <TypeContext.Provider value={{ type: inventoryTypeEnum.IN, no: state && state.no, stockType: state && state.stockType }}>
      <StockBillMainContent />
    </TypeContext.Provider>
  )
}
export default StockIn
